import { formatInTimeZone } from "date-fns-tz";

/**
 * Detalle del turno en conflicto que devuelve el backend (HTTP 409, code "OVERLAP")
 * cuando se intenta agendar un turno solapado sin confirmación de sobreturno.
 */
export type ConflictInfo = {
  startTime: string;
  endTime: string;
  clientName: string;
  staffName: string | null;
  count: number;
};

/** Mensaje de confirmación de sobreturno con el horario y cliente del turno solapado. */
export function overlapConfirmMessage(conflict: ConflictInfo, timeZone: string): string {
  const ini = formatInTimeZone(new Date(conflict.startTime), timeZone, "HH:mm");
  const fin = formatInTimeZone(new Date(conflict.endTime), timeZone, "HH:mm");
  const quien = conflict.staffName
    ? `${conflict.clientName} (${conflict.staffName})`
    : conflict.clientName;
  return `Este horario se superpone con el turno de ${ini}–${fin} de ${quien}.\n\n¿Confirmás que querés agendarlo como sobreturno?`;
}
